import { Injectable } from '@angular/core';

/** After-save preference values mirrored from backend
 *  `user_preferences.after_save_behavior`. */
export type AfterSaveBehavior = 'STAY' | 'BACK_TO_LIST';
const LS_KEY = 'crud.stay.in.page.after.save';


@Injectable({
  providedIn: 'root'
})
export class UIConfigurationService {

  /** Cached server-side after-save preference. Hydrated from
   *  /user/me via setAfterSave() (called by UserService after profile load
   *  + by the settings toggle on change). Null until first hydration —
   *  callers then fall back to localStorage. */
  private afterSaveCache: AfterSaveBehavior | null = null;

  constructor() {}

  /**
   * @returns `true` when the user prefers to stay on the edit page after
   *   saving, `false` when they prefer to return to the list. Reads the
   *   in-memory cache hydrated from `/user/me`. Falls back to localStorage
   *   for the brief window between page-load and profile resolution
   *   (and as a safety net for first-login users).
   */
  crudStayInPageAfterSave() : boolean {
    if (this.afterSaveCache === 'STAY') return true;
    if (this.afterSaveCache === 'BACK_TO_LIST') return false;
    return (/true/i).test(localStorage.getItem(LS_KEY) || 'false');
  }

  /** Update the in-memory cache + mirror to localStorage so the next
   *  page-load (before /user/me resolves) already matches. Called by
   *  UserService after loading the profile and by the settings toggle. */
  setAfterSave(value: AfterSaveBehavior): void {
    this.afterSaveCache = value;
    localStorage.setItem(LS_KEY, value === 'STAY' ? 'true' : 'false');
  }

  refreshTokenBeforeExpirationMs() : number {
    return +(localStorage.getItem("refresh.token.before.exipation.ms") || "60000");
  }

  /**
   * Whether this tenant exposes the per-authority "request access" workflow
   * on /settings/profile. Tasksense uses an authority-based access model so
   * the tab stays. Bookwise overrides to false.
   */
  showsRequestAccessTab() : boolean {
    return true;
  }
}
